import React, { useState, useEffect } from "react";
import ClientsSearchList from "../../../../components/ClientsSearchList";
import { translate } from "../../../../utils/Common";

const ClientIncidentSelect = (props) => {
  const { errors, register, nameShow, readOnly, sizeInput, setClientId } = props;
  const [selectedClientId, setSelectedClientId] = useState(null);

  const handleClientSelect = (clientId) => {
    setSelectedClientId(clientId);
    if (setClientId) {
      setClientId(clientId);
    }
  };

  useEffect(() => {
    // Reset when component unmounts or when we need to clear
    return () => {
      setSelectedClientId(null);
    };
  }, []);

  return (
    <div className={`input-group ${sizeInput || ""} w-100`} style={{ width: "100%" }}>
      <ClientsSearchList
        register={register}
        errors={errors}
        nameShow={nameShow}
        readOnly={readOnly}
        setSelectOption={handleClientSelect}
        isRequired={false}
        allClients={true}
      />
      <input
        type="hidden"
        name="clientId"
        value={selectedClientId || ""}
        ref={register({
          validate: value => value !== "" || translate("global.chooseValidClient")
        })}
      />
    </div>
  );
};

export default ClientIncidentSelect;
